var English = "Inglês";
var French = "Francês";
var German = "Alemão";
var Italian = "Italiano";
var Japanese = "Japonês";
var Korean = "Coreano";
var Portuguese = "Português";
var Russian = "Russo";
var Spanish = "Espanhol";
var Bahasa = "Bahasa";
var Thai = "Tailandês";
var Vietnamese = "Vietnamita";
var Turkish = "Turco";
var Arabic = "Árabe";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Chinês simplificado",
	"Chinese-Traditional": "Chinês tradicional",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
